module.exports = __webpack_public_path__ + "assets/img/loadingBlueGreen.b0d3b945.gif";